<template>
	<AppPageHeader>
		<template #left-side>
			<div>
				<div class="display-flex flex-row flex-align-center">
					<AnemicButton v-if="!extensionMode" @click="$router.back()" class="back-button" width="25" height="25" fab x-small>
						<AppIcon name="back" />
					</AnemicButton>
					<div class="user-name-text">{{ userFullName }}</div>
				</div>
				<template v-if="service">
					<div class="display-flex flex-row flex-align-center mt-1">
						<SIcon class="integration-container" :name="serviceSlug" width="24" />
						<div class="service-name-text ml-2 mr-2">{{ serviceName }}</div>
						<!-- <AppSwitch v-model="showAddOnsInService" class="swtch sml" style="margin-top: 2px !important" /> -->
					</div>
					<div class="page-description">Account: {{ serviceWorkspaceID }}</div>
				</template>
			</div>
		</template>
	</AppPageHeader>
</template>

<script>
import { mapGetters } from 'vuex';
import { getService } from '@/store/modules/apps/getters';
import AppPageHeader from '@/views/AppLayout/AppPageHeader.vue';
export default {
	name: 'ConnectionFeaturesHeader',
	props: {
		serviceID: { type: String },
		placementType: { type: String },
		extensionMode: { type: Boolean },
		serviceWorkspaceID: { type: String },
	},
	components: { AppPageHeader },
	computed: {
		...mapGetters(['userFullName']),
		...mapGetters([getService.fullPath]),
		service() {
			return this[getService.fullPath](this.serviceID);
		},
		serviceName() {
			return this.service.service_name;
		},
		serviceSlug() {
			return this.service.service_slug;
		},
		showAddOnsInService: {
			get() {
				// TODO navigation
				return true;
			},
			set(value) {
				return value;
			},
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.user-name-text {
	font-size: 12px;
	font-weight: 400;
	color: #4d4c52;
}
.back-button {
	margin-right: 5px;
	border-radius: 6px;
	border: 1px solid var(--grey-background);
}
.integration-container {
	background: transparent !important;
}
.service-name-text {
	font-size: 18px;
	font-weight: 600;
	color: #4d4c52;
}
</style>
